import React, { useContext } from 'react'
import styled from 'styled-components'

import ButtonArrow from '@components/Button/Button.Arrow'
import Heading, { headingConstants } from '@components/Heading'

import Section from '@components/Section'
import ScrollIndicator from '@components/ScrollIndicator'
import ShapeShifter from '@components/ShapeShifter'
import IntersectionObserver from '@components/IntersectionObserver'
import Transitions from '@components/Transitions'
import LayoutHeroMobile from '@components/Layout/Layout.Hero.Mobile'
import { ContactContext } from '@components/Contact/Contact.Context'

import media from '@styles/media'

function HomeHero() {
  const { toggleContact } = useContext(ContactContext)

  return (
    <LayoutHeroMobile>
      <HomeHeroContainer id="home-hero">
        <Section>
          <IntersectionObserver
            render={({ intersectionRatio: ir }) => (
              <ContentContainer
                style={ir ? { opacity: ir * ir } : { opacity: 1 }}
              >
                <TextContainer>
                  <Transitions.CSS.FadeIn>
                    <Heading.h1>
                      Hello I'm <strong>Julien</strong>, <i>self-made </i>{' '}
                      <strong>deSignLoper</strong>, crafting{' '}
                      <strong>userFacingThings</strong> to sustainibly improve
                      their<strong> experience</strong>.
                    </Heading.h1>
                    <MainText>
                      Today, I'm crafting mainly Interfaces, Code and Identity
                      to improve UX.
                    </MainText>
                    <Contact onClick={toggleContact}>
                      Press <Key>C</Key> anywhere to drop me a line.
                    </Contact>
                    <Mobile>
                      <ButtonArrow
                        as="button"
                        onClick={toggleContact}
                        text="Get in touch"
                      />
                    </Mobile>
                  </Transitions.CSS.FadeIn>
                </TextContainer>
                <ShapeShifter />
              </ContentContainer>
            )}
          />
          <ScrollIndicator />
        </Section>
      </HomeHeroContainer>
    </LayoutHeroMobile>
  )
}

export default HomeHero

const HomeHeroContainer = styled.div`
  ${media.desktop`
    #mirror-mask {
      display: none;
  `}
`

const TextContainer = styled.div`
  position: relative;
  z-index: 10;
  max-width: 570px;
  top: 10px;

  ${media.phablet`
    position: relative;
  `}
`

const MainText = styled.p`
  font-size: ${headingConstants.h1.fontsize};
  font-weight: 400;
  color: ${(p) => p.theme.colors.grey};
  line-height: ${headingConstants.h1.lineheight};
  margin-bottom: 50px;

  ${media.phablet`
    font-size: ${headingConstants.h1.fontsizeMobile};
    line-height: ${headingConstants.h1.lineheightMobile - 0.1};
  `};
`

const ContentContainer = styled.div`
  height: calc(100vh - 230px);
  min-height: 600px;
  padding-top: 10px;

  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${media.phablet`
    height: calc(100vh - 180px);
    min-height: 100%;
    padding: 0;
    top: -40px;
  `};

  ${media.desktop_medium`
    min-height: 360px;
  `};

  @media screen and (max-height: 800px) {
    min-height: 360px;
  }

  @media screen and (max-height: 648px) {
    top: -60px;
  }
`

const Contact = styled.button`
  color: ${(p) => p.theme.colors.grey};
  font-weight: 800;
  transition: color 0.25s ease;

  &:hover {
    color: #fff;

    span {
      background: #fff;
    }
  }

  ${media.desktop`
    display: none;
  `};
`

const Key = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 1px;
  color: #000;
  background: ${(p) => p.theme.colors.grey};
  font-size: 13px;
  width: 16px;
  height: 16px;
  border-radius: 2.5px;
  transition: background 0.25s ease;
`

const Mobile = styled.div`
  ${media.desktop_medium_up`
    display: none;
  `};
`
